import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { EmployeeCreateFormSchema } from '@modules/employees/submodules/create/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { EMPLOYEES_LIST_PERMISSIONS, EMPLOYEES_LIST_QUERY_KEY } from '@modules/employees/constants';
import { EMPLOYEES_CREATE_API_URL, EMPLOYEES_CREATE_QUERY_KEY } from '@modules/employees/submodules/create/constants';
import { useToastStore } from '@modules/toast/store';

export default function useEmployeeCreateMutation(): IContextMutationResult<
  void,
  Error,
  EmployeeCreateFormSchema
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, EmployeeCreateFormSchema>({
    mutationKey: [EMPLOYEES_CREATE_QUERY_KEY],
    mutationFn: (payload) => fetchPost<void>(
      EMPLOYEES_CREATE_API_URL,
      { personal: payload },
      { permission: EMPLOYEES_LIST_PERMISSIONS.CREATE },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [EMPLOYEES_LIST_QUERY_KEY] });
      displayPresetToast('created');
    },
  });
}
